<script setup lang="ts">
import type { Promocode } from '../model/interfaces'

import { faPen } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { usePromocodeActions } from '../model/promocode-actions.hook'

defineOptions({
  name: 'PromocodeRowActions',
})

const props = defineProps<{
  promocode: Promocode
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  toggle,
  openEdit,
} = usePromocodeActions({
  promocode: computed(() => props.promocode),
})
</script>

<template>
  <div
    ref="containerRef"
    class="promocode-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for ${promocode.name}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="promocode-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit promo code"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./PromocodeRowActions.scss" />
